module.exports = __webpack_public_path__ + "img/btg.4bd8c509.png";